import React, { FunctionComponent } from 'react';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { MenuItem } from '@mui/material';

import { enqueueError } from '@paragon/notification-tools';

import { showNotOnMobileDialog, showUserSettingsDialog } from '../../store/actions/popupActions';
import { useAppDispatch, useAppSelector, useIsClientInMobileMode } from '../hooks';

export const CURRENT_VERSION = 390;

interface Props {
  onClick: () => void;
}

export const OpenUserSettingsMenuItem: FunctionComponent<Props> = (props) => {
  const dispatch = useAppDispatch();
  const mobile = useIsClientInMobileMode();
  const userSettings = useAppSelector((state) => state.userSettings);

  const onShowDialogClick = () => {
    if (mobile) {
      dispatch(showNotOnMobileDialog('User settings are not yet available on mobile.'));
    } else if (userSettings) {
      dispatch(showUserSettingsDialog());
    } else {
      dispatch(enqueueError('Unable to access user settings.  Please reload the page and try again. '));
    }

    props.onClick();
  };

  return (
    <MenuItem onClick={onShowDialogClick}>
      <ManageAccountsIcon sx={{ mr: 1 }} />
      User Settings
    </MenuItem>
  );
};
